import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import createLink from "../../../../libs/createLink";

import {fetchAlbum, resetAlbum} from "../../../../creators/album";
import {fetchAlbumMedias, resetAlbumMedias} from "../../../../creators/album.medias";

import Thumb from '../../../components/Thumb';
import Pagination from '../../../components/Pagination';
import {Button} from "../../../components/Button";
import {LoadingBar, PageLoader} from "../../../components/Loader";
import history from "../../../../libs/history";
import Helmet from "react-helmet";
import {canonical, isNoFollowAlbum} from "../../../../libs/helper";
import Title from "../../../components/Title";
import _ from "lodash";
import ErrorNotFound from "../../ErrorNotFound";


class GalleryAlbum extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            byAlbumId: this.props.match.params.albumId,
            //sort: "-createdAt",
            limit: 30,
            page: this.props.match.params.page || 1
        };
        /*if(!this.props.isMe){
            this.filter = {
                ...this.filter,
                'file.state' : 1
            }
        }*/
        let userId = this.props.user && (this.props.user._id || "");
        this.state = {
            toggle: false,
            currentPage: this.props.match.params.page || 1,
            filter: this.filter,
            albumId: this.props.match.params.albumId || "",
            albumSlug: this.props.match.params.albumSlug || "",
            userId : userId,
            userSlug: this.props.user && (this.props.user.slug || ""),
            helmet : {
                title : "",
                description : "",
                canonicalUrl : ""
            }
        };
        this.getAlbumMedias = this.getAlbumMedias.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);

        this.props.fetchAlbum(this.props.match.params.albumId, {owner : userId});
        this.getAlbumMedias(this.state.filter);
    }

    getAlbumMedias(filter) {
        let albumId = this.props.album._id || this.filter.byAlbumId;
        this.props.fetchAlbumMedias(albumId, filter);
    }

    componentWillUnmount() {
        this.props.resetAlbumMedias();
        this.props.resetAlbum();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user) {
            this.setState({userId: prevProps.user._id, userSlug: prevProps.user.slug});
        }
        if(this.props.albumInitialized && (this.props.album.slug !== this.props.match.params.albumSlug)){
            let linkAlbum = createLink('userAlbum', {...this.props.user, album : {_id : this.props.album._id, slug : this.props.album.slug}});
            if (this.props.isMe) {
                linkAlbum = createLink('userMeAlbum', {...this.props.user, album : {_id : this.props.album._id, slug : this.props.album.slug}});
            }
            history.push(linkAlbum);
        }
    }

    handleChangePage(page, link) {
        let filter = {...this.state.filter, page};
        this.getAlbumMedias(filter);
        this.setState({filter, currentPage: page});
        if (page === 1) {
            this.props.history.push(link);
        } else {
            this.props.history.push(link + '/' + page);
        }
        window.scrollTo(0, 0);
    }


    render() {
        let linkAlbum = createLink('userAlbums', this.props.user);
        let totalPage = this.props.albumMedias ? Math.ceil(this.props.albumMediasTotal / this.state.filter.limit) : 0;
        let currentPage = this.state.currentPage > 0 ? parseInt(this.state.currentPage) : 1;
        let linkPagination = createLink('userAlbum', {...this.props.user, album : {_id : this.state.albumId, slug : this.state.albumSlug}});
        if (this.props.isMe) {
            linkPagination = createLink('userMeAlbum', {...this.props.user, album : {_id : this.state.albumId, slug : this.state.albumSlug}});
            linkAlbum = createLink('userMeAlbums', this.props.user);
        }

        let pageTitle = '';
        if(this.props.albumMediasInitialized){
            pageTitle = `${this.props.album.title} ${this.props.user.username} - Voissa`;
            if(this.props.album && this.props.album.count && this.props.album.count.photo >0 && this.props.album.count.video >0){
                pageTitle = `Photos et vidéos ${pageTitle}`;
            }
            else if(this.props.album && this.props.album.count && this.props.album.count.photo >0){
                pageTitle = `Photos ${pageTitle}`;
            }
            else if(this.props.album && this.props.album.count && this.props.album.count.video >0){
                pageTitle = `Vidéos ${pageTitle}`;
            }
            pageTitle = currentPage >1 ? `${pageTitle} ( page ${currentPage} )` : pageTitle;

        }
        if(_.get(this.props.albumError,"statusCode") === 404) {
            return (
                <div className="album-page">
                    <div className="card big album-grid">
                        <ErrorNotFound/>
                    </div>
                </div>
            )
        }

        return !this.props.albumInitialized || !this.props.albumMediasInitialized ? (
                <div className="album-page">
                    <div className="card big album-grid">
                        <PageLoader/>
                    </div>
                </div>
            ) : (
                <div className="album-page">
                    <Helmet>
                        <title>{pageTitle}</title>
                        <meta name="description" content={this.props.album.description} />
                        {this.props.album && this.props.album.count && this.props.album.count.photo === 0 && this.props.album.count.video === 0 && (<meta name="robots" content="noindex" />)}
                        {currentPage === 2 && (<link rel="prev" href={canonical(linkPagination, "", "album")} />)}
                        {currentPage >= 3 && (<link rel="prev" href={`${canonical(`${linkPagination}/${(currentPage - 1)}`, "", "album")}`} />)}
                        <link rel="canonical" href={currentPage >1 ? `${canonical(`${linkPagination}/${currentPage}`, "", "album")}` : canonical(linkPagination, "", "album")} />
                        {currentPage < totalPage && (<link rel="next" href={`${canonical(`${linkPagination}/${(currentPage + 1)}`, "", "album")}`} />)}
                        {isNoFollowAlbum(this.props.album) ? <meta name="robots" content="noindex" /> : null}
                    </Helmet>
                    <div className="card big album-grid">
                        <div className="album">
                            <div className="btn-group back-to-album">
                                <Button size={"small"}
                                        btnStyle={"primary-reverse"}
                                        to={this.props.isMe && (this.props.user._id) ? createLink('userMeAlbums', this.props.user) : linkAlbum}
                                        icon={"chevron-left"}
                                        content={"Retour aux albums"}/>
                            </div>
                            <div className="album-top-infos">
                                {/*{this.props.albumMediasInitialized && (<Breadcrumbs data={breadCrumbsData} />)}*/}
                                <Title heading={"heading-1"} display={"display-3"}>{this.props.album.title || ""}</Title>
                                <div className="album-description">{this.props.album.description || ""}</div>
                            </div>
                            {totalPage > 1 && (
                                <Pagination
                                    currentPage={this.state.currentPage}
                                    pagesCount={totalPage}
                                    handleChangePage={this.handleChangePage}
                                    link={linkPagination}
                                />
                            )}
                            {this.props.albumMediasLoading && (
                                <LoadingBar />
                            )}
                            {this.props.albumMediasTotal !== 0 && (
                                <div className="wrapper-album">
                                    {this.props.albumMedias && this.props.albumMedias.error ? this.props.albumMedias.error : (
                                        <div
                                            className={`wrapper-thumb ${this.props.type === "album-page" ? 'album-out' : 'album-in'}`}>
                                            {this.props.albumMedias && this.props.albumMedias.map((item) => <Thumb key={item._id} {...item}
                                                                                         isMe={this.props.isMe}/>)}
                                        </div>
                                    )}
                                </div>
                            )}
                            {this.props.albumMediasTotal === 0 && (
                                <div className={"no-content"}>Aucun média dans cet album</div>
                            )}
                            {this.props.albumMediasLoading && (
                                <LoadingBar />
                            )}
                            {totalPage > 1 && (
                                <Pagination
                                    currentPage={currentPage}
                                    pagesCount={totalPage}
                                    handleChangePage={this.handleChangePage}
                                    link={linkPagination}
                                />
                            )}
                        </div>
                    </div>
                </div>
            )
    }
}


const mapStateToProps = (state) => {
    return {
        album: state.album.data,
        albumError : state.album.error,
        albumLoading: state.album.loading,
        albumInitialized: state.album.initialized,

        albumMedias: state.albumMedias.data,
        albumMediasLoading: state.albumMedias.loading,
        albumMediasInitialized: state.albumMedias.initialized,
        albumMediasTotal: state.albumMedias.total
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchAlbumMedias,
    resetAlbumMedias,

    fetchAlbum,
    resetAlbum,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(GalleryAlbum);
